export enum PermissionToSend{
    IMPLICIT = "implicit",
    EXPLICIT = "explicit",
    PENDING_CONFIRMATION = "pending_confirmation",
    UNSUBSCRIBED = "unsubscribed",
    TEMP_HOLD = "temp_hold",
    NOT_SET = "not_set"
}